import axios from "axios";

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "http://localhost:8000",
  timeout: 60000,
});

// Request interceptor
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

import Swal from "sweetalert2";

// ... (keep existing code)

// Response interceptor
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/sign-in";
      } else if (status === 422) {
        // Validation Error
        let message = data.message || "驗證失敗";
        if (data.errors) {
          const errors = Object.values(data.errors).flat();
          message = errors.join("<br>");
        }
        Swal.fire({
          icon: "error",
          title: "驗證失敗",
          html: message,
        });
      } else {
        // Other errors
        Swal.fire({
          icon: "error",
          title: "發生錯誤",
          text: data.message || "系統發生錯誤，請稍後再試",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "連線錯誤",
        text: "無法連接到伺服器，請檢查網路連線",
      });
    }
    return Promise.reject(error);
  }
);

export default service;
